/* eslint-disable import/no-unresolved */
import React from "react";
import ShopProductPageDetail from "components/pages/user/products/ShopProductPageDetail";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopProductPageDetail = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopProductPageDetail {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopProductPageDetail);
